import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const SubmitEmail = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/business-updates-revamp/components/SubmitEmailContent'
      )
  ),
  Header: lazy(
    () =>
      import(
        'components/direct-sales/business-updates-revamp/components/SubmitEmailHeader'
      )
  )
};

export default SubmitEmail;
